import PizZip from 'pizzip';
import Docxtemplater from 'docxtemplater';
import { saveAs } from 'file-saver';

import toShort from '../../../../../services/utils/dateParser';
import { minutesToDuration } from '../../../../../services/utils/tna.js';

import uk_b1_1_b2_type_docx from '../../../../../library/templates/sf104-02-course-approval-b1-1-b2-type.docx';
import uk_b1_1_type_docx from '../../../../../library/templates/sf105-02-course-approval-b1-1-type.docx';
import uk_b2_type_docx from '../../../../../library/templates/sf112-02-course-approval-b2-type.docx';

const ExportProgramToDoc = ({ data, atas, tnaDetails }) => {
    const templates = {
        22: uk_b1_1_b2_type_docx,
        5: uk_b1_1_type_docx,
        9: uk_b2_type_docx,
    };

    console.log(tnaDetails);

    const loadFile = (url, callback) => {
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                console.log(response);
                return response.arrayBuffer();
            })
            .then((data) => callback(null, data))
            .catch((err) => callback(err, null));
    };

    const ataData = atas.reduce((acc, ata) => {
        acc[`a_${ata.ataId}_d`] = ata.totalAtaDuration || '00:00';
        acc[`a_${ata.ataId}_q`] = ata.mcqQty || 0;
        acc[`a_${ata.ataId}_a`] = ata.ataMethods.join(', ') || '';
        return acc;
    }, {});

    const docData = {
        programTitle: data.programTitle || '',
        programNo: data.programNo || '',
        courseCreatedAt: toShort(data.createdOn) || '',
        courseUpdatedAt: toShort(data.modifiedOn) || '',
        tnaNo: tnaDetails?.tnaData?.tnaNo || '', // add tnaNo with fetched data if needed
        tnaRev: tnaDetails?.tnaRev || '', // add tnaRev with fetched data if needed
        tnaDate: toShort(tnaDetails?.tnaDate) || '', // add tnaDate with fetched data if needed
        aircraftAirframe: data.aircraftTypeAirframe || '',
        aircraftPowerPlant: data.aircraftTypePowerplant || '',
        tt_only: data.licenseCategoryId !== 22 ? '☑' : '☐',
        tt_pt: data.licenseCategoryId === 22 ? '☑' : '☐',
        ...ataData,
        total_d: minutesToDuration(tnaDetails?.tnaTotalDurationMin) || '00:00',
        total_q: tnaDetails?.tnaTotalMcq || 0,
        pt_devices: data.licenseCategoryId === 22 ? '6' : '',
        // methods: 'tbd',
        today: toShort(new Date()),

    };

    const generateDocument = () => {
        if (!data || !data.licenseCategoryId || !templates[data.licenseCategoryId]) {
            console.error('No valid template found for the given license category ID.');
            return;
        }
        loadFile(templates[data.licenseCategoryId], (err, content) => {
            if (err) {
                console.error('Error loading the template:', err);
                return;
            }

            // if (true) return; // TODO: remove this line after testing
            try {
                const zip = new PizZip(content);
                const doc = new Docxtemplater(zip, {
                    paragraphLoop: true,
                    linebreaks: true,
                });

                doc.setData(docData);

                doc.render();

                const blob = doc.getZip().generate({
                    type: 'blob',
                    mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                });

                saveAs(blob, `#${data.programNo}_${data.programTitle}.docx`);
            } catch (error) {
                console.error('Error rendering the document:', error);
            }
        });
    };

    return (
        <div>
            <button
                style={{
                    backgroundColor: 'rgb(21, 129, 6)',
                    border: 'none',
                    borderRadius: '5px',
                    padding: '5px 10px',
                    color: 'white',
                    margin: '2px 0px',
                    marginRight: '5px',
                }}
                onClick={generateDocument}
            >
                UK Export
            </button>
        </div>
    );
};

export default ExportProgramToDoc;
